export default __webpack_public_path__ + "static/media/clinician_banner.7f3578cf.jpg";